import Udesk from 'Udesk';
import React, { FC, memo, useState } from 'react';
import { usePageParams } from '../../hooks';
import { useRequest } from 'ahooks';
import Page from 'Component/common/udesk-qa-page-layout';
import { Button, Form, Input, message, Spin } from 'udesk-ui';
import ImgUpload from 'Component/common/img-upload';
import styled from 'styled-components';
import { getCurrentRouteName } from 'Udesk/system/subApp';
import { postMainProducts } from 'src/api/mainProducts';
import { getMainProductsById, putMainProductsById } from 'src/api/mainProducts/{id}';
import { MainProductCreateRequest } from 'src/api/types';
import UdeskLocales from 'UdeskLocales';

const FormWrapper = styled.div``;

interface TemplateProps {
    history?: any;
    match?: any;
}

interface FormModel extends Omit<MainProductCreateRequest, 'id'> {}

const Template: FC<TemplateProps> = memo((props) => {
    const { history } = props;

    const { id, isReady } = usePageParams(props);

    const onBack = () => {
        Udesk.ui.routing.transitionTo({
            history,
            routeName: getCurrentRouteName('productManage'),
        });
    };

    const [form] = Form.useForm<FormModel>();

    const { loading: getLoading } = useRequest(
        () => getMainProductsById({ segments: { id: +id! } }),
        {
            ready: isReady,
            onSuccess: (res) => {
                form.setFieldsValue({
                    name: res.data?.name,
                    description: res.data?.description,
                    image: res.data?.image,
                });
            },
        }
    );

    const [saveLoading, setSaveLoading] = useState(false);

    const onFinish = (values: FormModel) => {
        form.validateFields().then(() => {
            setSaveLoading(true);
            if (!isReady) {
                postMainProducts(values)
                    .then((res) => {
                        message.success(/* 保存成功 */UdeskLocales['current'].pages.conversationAnalysis.productManage.components.baseInfo.index.saveSuccessful);
                        Udesk.ui.routing.transitionTo({
                            history,
                            routeName: getCurrentRouteName('productManageDetailSubProduct'),
                            pathParams: {
                                id: res.data?.id,
                            },
                        });
                    })
                    .finally(() => {
                        setSaveLoading(false);
                    });
            } else if (isReady) {
                putMainProductsById(values, { segments: { id: id! } })
                    .then(() => {
                        message.success(/* 保存成功 */UdeskLocales['current'].pages.conversationAnalysis.productManage.components.baseInfo.index.saveSuccessful);
                    })
                    .finally(() => {
                        setSaveLoading(false);
                    });
            } else {
                setSaveLoading(false);
            }
        });
    };

    return (
        <Page
            pageBodyClassName="product-manage-base-info"
            title={/* 基础信息 */UdeskLocales['current'].pages.conversationAnalysis.productManage.components.baseInfo.index.basicInformation}
            padding={true}
            onBack={onBack}
        >
            <FormWrapper>
                <Spin spinning={getLoading || saveLoading}>
                    <Form<FormModel>
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 12 }}
                        form={form}
                        onFinish={onFinish}
                    >
                        <Form.Item
                            label={/* 产品名称 */UdeskLocales['current'].pages.conversationAnalysis.productManage.components.baseInfo.index.productName}
                            name="name"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item label={/* 产品描述 */UdeskLocales['current'].pages.conversationAnalysis.productManage.components.baseInfo.index.productDescription} name="description">
                            <Input.TextArea rows={4} />
                        </Form.Item>

                        <Form.Item label={/* 产品图片 */UdeskLocales['current'].pages.conversationAnalysis.productManage.components.baseInfo.index.productPicture} name="image">
                            <ImgUpload />
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 4 }}>
                            {isReady ? (
                                <Button type="primary" htmlType="submit">{/* 保存 */}{UdeskLocales['current'].pages.conversationAnalysis.productManage.components.baseInfo.index.preserve}</Button>
                            ) : (
                                <Button type="primary" htmlType="submit">{/* 下一步 */}{UdeskLocales['current'].pages.conversationAnalysis.productManage.components.baseInfo.index.nextStep}</Button>
                            )}
                        </Form.Item>
                    </Form>
                </Spin>
            </FormWrapper>
        </Page>
    );
});

export default Template;
